/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Row,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { startCase, isFinite } from 'lodash';
import './Worksheet.scss';

function BreakdownOperation({ operationEntry }) {
  const [expanded, setExpanded] = useState(false);
  if (!operationEntry) return null;
  let operation;
  switch (operationEntry.operation) {
    case 'add':
      operation = '+';
      break;
    case 'subtract':
      operation = '-';
      break;
    case 'multiply':
      operation = '×';
      break;
    case 'divide':
      operation = '/';
      break;
    default:
      operation = `> ${startCase(operationEntry.operation)}`;
  }
  const hasSubOperations = operationEntry.suboperations?.length > 0;

  return (
    <div
      className="breakdown-operation"
      onClick={event => {
        event.preventDefault();
        event.stopPropagation();
        setExpanded(e => !e);
      }}
    >
      {operation}{' '}
      <span
        className={
          hasSubOperations ? 'breakdown-operation-expandable-label' : 'false'
        }
      >
        {operationEntry.name}
      </span>
      {isFinite(operationEntry.value) ? `: ${operationEntry.value}` : ''}{' '}
      {expanded &&
        operationEntry.suboperationsTags?.map((tag, index) => (
          <div key={index} className="breakdown-operation-tags">
            Tag: {tag.name} = {tag.value}
          </div>
        ))}
      {hasSubOperations && expanded && (
        <div>
          {operationEntry.suboperations?.map((subOperationEntry, index) => (
            <BreakdownOperation
              key={index}
              operationEntry={subOperationEntry}
            />
          ))}
        </div>
      )}
    </div>
  );
}

BreakdownOperation.propTypes = {
  operationEntry: PropTypes.object,
};

function SummaryBreakdownRow(props) {
  const { name, label, offer } = props;
  const [expanded, setExpanded] = useState(false);
  const value = offer?.[name];
  const breakdown = offer?.[`${name}Raw`];
  return (
    <>
      <Row>
        <FormGroup
          controlId={name}
          className="formGroup form-inline form-group"
        >
          <Col md={7}>
            <ControlLabel
              className="summary-breakdown-row-label"
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                setExpanded(e => !e);
              }}
            >
              {expanded ? <>&#x25BC;</> : <>&#x25B6;</>} {label}
            </ControlLabel>
          </Col>
          <Col md={2} className="text-right">
            <FormControl type="number" name={name} value={value} readOnly />
          </Col>
        </FormGroup>
      </Row>
      {expanded &&
        breakdown?.operations?.map((operationEntry, index) => (
          <BreakdownOperation key={index} operationEntry={operationEntry} />
        ))}
    </>
  );
}

SummaryBreakdownRow.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  offer: PropTypes.object,
};

export default SummaryBreakdownRow;
